import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { pushDataLayer } from "../gtm";

export default function Step1({ formData, setFormData, next }) {
  const handleSubmit = (e) => {
    e.preventDefault();

    // Verificamos qué campos están vacíos
    const faltantes = [];
    if (!formData.nombre?.trim()) faltantes.push("Nombre");
    if (!formData.apellido?.trim()) faltantes.push("Apellido");

    if (faltantes.length > 0) {
      // Mostramos SweetAlert con los campos que faltan
      Swal.fire({
        icon: "error",
        title: "Errores en el formulario",
        text: `Por favor completá: ${faltantes.join(", ")}`,
        customClass: {
          popup: "swal2-no-radius"
        },
        confirmButtonText: "Entendido",
        confirmButtonColor: "#000000",
        backdrop: "rgba(0, 0, 0, 0.8)",
      });
      return;
    }

    // Si todo está completo, dispara evento y avanzamos al siguiente paso
    pushDataLayer('paso3_contacto');
    next();
  };

  return (
    <div className="form-container">
      <h2 className="form-title">¿Cómo te llamás?</h2>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className="mb-4">
          <Form.Label>
            Nombre <span style={{ color: "#000000" }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Carlos"
            value={formData.nombre}
            onChange={(e) =>
              setFormData({ ...formData, nombre: e.target.value })
            }
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>
            Apellido <span style={{ color: "#000000" }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="García"
            value={formData.apellido}
            onChange={(e) =>
              setFormData({ ...formData, apellido: e.target.value })
            }
          />
        </Form.Group>

        <div className="text-end">
          <Button variant="primary" type="submit">
            Aceptar
          </Button>
        </div>
      </Form>
    </div>
  );
}
